import { ReactElement, ReactNode } from 'react';

import TenantsProviderContext from 'features/tenants/providers/tenants-provider/contexts/tenants-provider-context';
import useTenantsProviderState from 'features/tenants/providers/tenants-provider/state/tenants-provider-state';

export type TenantsProviderProps = {
  children: ReactNode;
};

const TenantsProvider = ({ children }: TenantsProviderProps): ReactElement => (
  <TenantsProviderContext value={useTenantsProviderState()}>{children}</TenantsProviderContext>
);

export default TenantsProvider;
